var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-row" },
    [
      _vm.elHelp.length > 0 && !_vm.readonly
        ? _c("i", {
            staticClass: "fa fa-question pull-right",
            attrs: {
              "aria-expanded": !_vm.triggerShowHelp,
              "aria-controls": "help-" + (_vm.elName || _vm.elId)
            },
            on: {
              click: function($event) {
                _vm.triggerShowHelp = !_vm.triggerShowHelp
              }
            }
          })
        : _vm._e(),
      _c("label", { staticClass: "form-label", attrs: { for: _vm.elId } }, [
        _vm._v(" " + _vm._s(_vm.elLabel) + " ")
      ]),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.curValue,
              expression: "curValue"
            }
          ],
          class: _vm.getClasses,
          attrs: {
            name: _vm.elName || _vm.elId,
            id: _vm.elId,
            disabled: _vm.readonly
          },
          on: {
            change: function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.curValue = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            }
          }
        },
        _vm._l(_vm.elOptions.options.option, function(optionObject, i) {
          return _c(
            "option",
            {
              key: i,
              domProps: { value: _vm.simpleValue(optionObject.value) }
            },
            [
              _vm._v(
                "\n            " + _vm._s(optionObject.text) + "\n        "
              )
            ]
          )
        }),
        0
      ),
      _c("transition", { attrs: { name: "fade" } }, [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showHelp,
              expression: "showHelp"
            }
          ],
          staticClass: "question-option-help well",
          attrs: { id: "help-" + (_vm.elName || _vm.elId) },
          domProps: { innerHTML: _vm._s(_vm.elHelp) }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }